import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import 'semantic-ui-css/semantic.min.css';
import { Provider } from 'react-redux';
import{store} from './helpers';
import { App } from './components';


ReactDOM.render((
    <Provider store={store}>
        <App />
    </Provider> 

), document.getElementById('root'));



// WEBPACK FOOTER //
// ./src/index.js